import React, { useState, useEffect } from 'react'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import * as Icons from '../../../assets/Icons'
import CustomTheme from '../../../assets/CustomTheme'
import {Text} from '../../../assets/Text'
import Logo from '../../../images/icons/Logo.svg'
const LoginBGImg = require('../../../images/login/landing_image.png')

const { innerWidth, innerHeight } = window

const Wireframe = props => {
    return <CustomTheme>
    <Grid container
        sx={{ 
            height: { md: '100vh' }, 
            maxHeight: { md: '100vh' }, 
            overflow:'auto',
            flexDirection: {
                md: 'row',
                sm: 'column'
            }
        }}
    >
        <Grid item xs sm md
            sx={{
                backgroundColor: 'theme.primary.main',
                height: {
                    xs: '240px',
                    sm: '400px',
                    md: '100vh'
                },
                width: {
                    xs: '100%',
                    sm: '100%',
                    md: '50%'
                },
                p: {
                    xs: 2,
                    sm: 3,
                    md: 8
                },
                position: {
                    xs: 'relative',
                    sm: 'relative',
                    md: 'fixed'
                }
            }}
            style={{
                backgroundImage: `url(${LoginBGImg})`,
                backgroundBlendMode: 'hard-light',
                backgroundColor: '#528586',
                backgroundSize: 'cover',
                backgroundPosition: 'center center'
            }}
        >
            <Grid container 
                direction={"column"}
                justifyContent={"center"}
                alignItems={"center"}
                sx={{
                    width: '100%',
                    height: '100%'
                }}
            >
                <Grid 
                    item
                    sx={{
                        width: {
                            xs: '80px',
                            md: '160px'
                        }
                    }}
                >
                    <Icons.Logo style={{ width: '100%' }}/>
                </Grid>
                <Grid 
                    item
                    sx={{
                        bgcolor: 'background.default',
                        p: {
                            xs: 1,
                            sm: 1,
                            md: 3
                        },
                        mt: {
                            xs: 1,
                            sm: 1,
                            md: 2
                        },
                        borderRadius: 0.5
                    }}
                >
                    <Text variant="h6">Peer Social Support</Text>
                </Grid>
            </Grid>
        </Grid>
        {/*<Grid item xs={12} sm={10} md={8} className='mx-auto d-flex align-items-start'>
            {cards}
        </Grid>*/}
        <Grid item sm md={6}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                pt: {
                    xs: 2,
                    sm: 3,
                    md: 2
                },
                px: {
                    xs: 3,
                    sm: 10,
                    md: 10
                },
                pb: 10,
                position: {
                    xs: 'relative',
                    sm: 'relative',
                    md: 'absolute'
                },
                overflow: 'auto',
                maxHeight: {
                    xs: 'auto',
                    sm: 'auto',
                    md: '100vh'
                },
                right: 0,
                width: {
                    sm: '100%',
                    md: '640px'
                },
                bgcolor: 'background.default'
            }}
        >
            {props.children}
        </Grid>

    </Grid>
    </CustomTheme>
}

export default Wireframe